import $axios from 'axios'
import {


    meragejobList,
    QUERY_NO_LOGIN_POSITION_LIST,
} from '../config/uri'




export function getJobList(params) {
    return $axios.post(meragejobList, params)
}
/**
 * 未登录职位信息
 * @param {*} params
 * @returns
 */
export function queryNoLoginPositionList(params) {
    return $axios.post(QUERY_NO_LOGIN_POSITION_LIST, params)
}
